<template>
  <el-dialog
    title="删除确认"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align: center;">
      <p>确定删除供应商 {{ deleteResourceSupplierInfo.supplierName }} 吗？</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">点错了</el-button>
      <el-button type="primary" @click="deleteResourceSupplier">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteResourceSupplier } from '@/api/goods/resourceSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteResourceSupplier',
  data() {
    return {
      dialogVisible: false,
      deleteResourceSupplierInfo: {}
    }
  },
  methods: {
    open(row) {
      this.deleteResourceSupplierInfo = { ...row }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteResourceSupplierInfo = {}
    },
    deleteResourceSupplier() {
      const params = {
        rsId: this.deleteResourceSupplierInfo.rsId,
        shopId: getShopId()
      }
      deleteResourceSupplier(params)
        .then(response => {
          console.log(response)
          this.$message.success('删除成功')
          this.closeDialog()
          this.$emit('refresh')
        })
        .catch(error => {
          this.$message.error(error.message || '删除失败')
        })
    }
  }
}
</script>